import { useState } from 'react';
import { CaretDown, CaretRight } from '@phosphor-icons/react';

const SECTION_LABELS = {
    'objektkategorie': 'Objektkategorie',
    'geo': 'Geo/Adresse',
    'kontaktperson': 'Kontaktperson',
    'preise': 'Preise',
    'flaechen': 'Flächen',
    'ausstattung': 'Ausstattung',
    'zustand_angaben': 'Zustand & Energie',
    'freitexte': 'Freitexte',
    'anhaenge': 'Anhänge',
    'verwaltung_techn': 'Verwaltung (technisch)',
    'verwaltung_objekt': 'Verwaltung (Objekt)',
    'energiepass': 'Energiepass',
    'objektart': 'Objektart',
    'vermarktungsart': 'Vermarktungsart',
};

function flattenObject(obj, prefix = '', result = []) {
    if (!obj || typeof obj !== 'object') return result;

    for (const [key, value] of Object.entries(obj)) {
        const path = prefix ? `${prefix}.${key}` : key;
        if (value === null || value === undefined) continue;

        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            result.push({ path, value: String(value), isAttr: key.startsWith('@') });
        } else if (Array.isArray(value)) {
            value.forEach((item, idx) => {
                if (typeof item === 'string' || typeof item === 'number') {
                    result.push({ path: `${path}[${idx}]`, value: String(item), isAttr: false });
                } else {
                    flattenObject(item, `${path}[${idx}]`, result);
                }
            });
        } else {
            flattenObject(value, path, result);
        }
    }
    return result;
}

export function XmlTreeView({ data }) {
    const topKeys = Object.keys(data || {});

    return (
        <div className="space-y-1">
            {topKeys.map((sectionKey) => (
                <SectionBlock key={sectionKey} sectionKey={sectionKey} data={data[sectionKey]} />
            ))}
        </div>
    );
}

function SectionBlock({ sectionKey, data }) {
    const [open, setOpen] = useState(sectionKey === 'zustand_angaben' || sectionKey === 'energiepass');
    const label = SECTION_LABELS[sectionKey] || sectionKey;
    const isEnergy = sectionKey === 'energiepass' || sectionKey === 'zustand_angaben';

    // For leaf values at top level
    if (typeof data === 'string' || typeof data === 'number' || typeof data === 'boolean') {
        return (
            <div className="flex items-baseline gap-2 py-0.5 text-sm">
                <span className="font-mono text-muted-foreground shrink-0">{label}:</span>
                <span className="font-medium">{String(data)}</span>
            </div>
        );
    }

    const flatEntries = flattenObject(data);

    return (
        <div className="py-0.5">
            <button
                onClick={() => setOpen(!open)}
                className={`flex items-center gap-1.5 text-sm font-medium hover:text-primary transition-colors ${isEnergy ? 'text-primary font-semibold' : ''}`}
            >
                {open ? <CaretDown size={12} /> : <CaretRight size={12} />}
                <span>{label}</span>
                <span className="text-xs text-muted-foreground font-normal">({flatEntries.length} Werte)</span>
            </button>
            {open && (
                <div className="ml-4 mt-1 border-l border-border/50 pl-3 space-y-0.5">
                    {flatEntries.map((entry, idx) => (
                        <div key={idx} className="flex items-baseline gap-2 text-sm py-0.5">
                            <span className={`font-mono shrink-0 text-xs ${entry.isAttr ? 'text-orange-600' : 'text-muted-foreground'}`}>
                                {entry.path}:
                            </span>
                            <span className="font-medium break-all">{entry.value}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
